import { useState } from 'react'
import './BoxListChart.scss'

import Growth from './BoxListChart/Growth'
import Overview from './BoxListChart/Overview'
import Value from './BoxListChart/Value'
import Momentum from './BoxListChart/Momentum'
import Report from './BoxListChart/Report'
import BackTestV2 from './BoxListChart/BackTestV2'
import InvestmentTransaction from './BoxListChart/TransactionStatistics'
import { useDispatch, useSelector } from 'react-redux'
import { changeTabActive } from 'store/actionReducers/StocksAnalysisStore'

export default function BoxListChart() {
  const StocksAnalysisStore = useSelector((state: any) => state?.StocksAnalysisStore)
  const tabActive = StocksAnalysisStore?.tabActive
  const dispatch = useDispatch();

  const handleChangePageActive = (tab: string) => {
    dispatch(changeTabActive({ tabActive: tab }))
  }

  return (
    <>
      <div className="jCgjzJxjbg">
        <div className="vHTgvywnjz">
          <div onClick={() => handleChangePageActive('tong-quan')} className={`dbSHFWzcaE ${tabActive === 'tong-quan' ? 'pLPTyGolrf' : ''}`}>Tổng quan</div>
          <div onClick={() => handleChangePageActive('tang-truong')} className={`dbSHFWzcaE prnstkjulr ${tabActive === 'tang-truong' ? 'pLPTyGolrf' : ''}`}>Tăng trưởng</div>
          <div onClick={() => handleChangePageActive('gia-tri')} className={`dbSHFWzcaE prnstkjulr ${tabActive === 'gia-tri' ? 'pLPTyGolrf' : ''}`}>Giá trị</div>
          <div onClick={() => handleChangePageActive('dong-luong')} className={`dbSHFWzcaE prnstkjulr ${tabActive === 'dong-luong' ? 'pLPTyGolrf' : ''}`}>Động lượng</div>
          <div onClick={() => handleChangePageActive('bao-cao')} className={`dbSHFWzcaE ${tabActive === 'bao-cao' ? 'pLPTyGolrf' : ''}`}>Báo cáo</div>
          <div onClick={() => handleChangePageActive('back-test')} className={`dbSHFWzcaE prnstkjulr ${tabActive === 'back-test' ? 'pLPTyGolrf' : ''}`}>Back test</div>
          <div onClick={() => handleChangePageActive('thong-ke-giao-dich')} className={`dbSHFWzcaE ${tabActive === 'thong-ke-giao-dich' ? 'pLPTyGolrf' : ''}`}>Thống kê giao dịch</div>
        </div>
        <div className='bltxbalhgb'>
          <div className={`pbyanwqfzf ${tabActive === 'tong-quan' ? 'rvhacijfbb' : ''}`}><Overview /></div>
          <div className={`ofzeppyynf pbyanwqfzf ${tabActive === 'tang-truong' ? 'rvhacijfbb' : ''}`}><Growth /></div>
          <div className={`ofzeppyynf pbyanwqfzf ${tabActive === 'gia-tri' ? 'rvhacijfbb' : ''}`}><Value /></div>
          <div className={`ofzeppyynf pbyanwqfzf ${tabActive === 'dong-luong' ? 'rvhacijfbb' : ''}`}><Momentum /></div>
          <div className={`xrldjxcwxf pbyanwqfzf ${tabActive === 'bao-cao' ? 'rvhacijfbb' : ''}`}><Report /></div>
          <div className={`ofzeppyynf pbyanwqfzf ${tabActive === 'back-test' ? 'rvhacijfbb' : ''}`}><BackTestV2 /></div>
          <div className={`pbyanwqfzf ${tabActive === 'thong-ke-giao-dich' ? 'rvhacijfbb' : ''}`}><InvestmentTransaction /></div>
        </div>
      </div>
    </>
  )
}